import { Box, Heading } from '@hawkins/components';
import { Grid } from 'src/domains/shared/components/Grid';
import { CalculatorOutputProps } from './types';
import { resolutionAsText } from '../FramingAndWorkingResolutionCalculators/components/CalculatorOutput/outputUtils';

export const CalculatorOutput = ({
  minimumActiveImageResolution,
  minimumCapturedResolution,
}: CalculatorOutputProps) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    width="80%"
  >
    <Grid gap="Space16">
      <Grid gap="Space2">
        <Heading level={0} align="center">
          Minimum Active Image Resolution
        </Heading>
        <Heading level={4} align="center">
          {resolutionAsText(minimumActiveImageResolution)}
        </Heading>
      </Grid>

      <Grid gap="Space2">
        <Heading level={0} align="center">
          Minimum Captured Resolution
        </Heading>
        <Heading level={4} align="center">
          {resolutionAsText(minimumCapturedResolution)}
        </Heading>
      </Grid>
    </Grid>
  </Box>
);
